export default __webpack_public_path__ + "static/media/information-icon.30ddcb89.svg";